import { useQuery } from 'react-query';
import { httpClient } from '../../../utils/http/http-client';
import { GetPromoAccessQueryParams, PromoAccess } from '@repo/types/promo';

export const useGetPromoAccess = (
  id: number | undefined,
  query: Partial<GetPromoAccessQueryParams>,
) =>
  useQuery(
    ['getPromoAccess', query],
    () =>
      httpClient.GET<GetPromoAccessQueryParams, PromoAccess>(
        `release/${id}/promo/access`,
        query as GetPromoAccessQueryParams,
      ),
    { enabled: Boolean(query.accessCode) && Boolean(id) },
  );
